import Link from 'next/link';
import isObject from 'lodash/isObject';
import styles from '@features/homepage/sections/MainCategories/MainCategoriesSection.styles';
import Icon from '@components/icons/Icon';
import theme from '@styles/theme';
import { ECarouselType } from '@components/Carousel/typescript';
import FurnituresCarousel from '@components/FurnituresCarousel/FurnituresCarousel';
import { IDescriptionWithSlidesBlock } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import sanitizeHtml from '@utils/sanitizeHtml';
import prepareURLByCMSLink from '@utils/prepareURLByCMSLink';
type PropsType = {
  mainCategories: IDescriptionWithSlidesBlock;
  defaultBackground?: string;
  isFirst?: boolean;
};
const MainCategoriesSection = ({
  mainCategories,
  defaultBackground = theme.rawColors.beige500,
  isFirst = false
}: PropsType) => <section sx={styles.section(mainCategories.background || defaultBackground)} data-testid="MainCategoriesSection">
    <div sx={styles.descriptionStyles} data-cy="MainCategoriesDescription">
      {mainCategories.title && <Heading h={isFirst ? 1 : 2} headingType={2} mobile>
          {mainCategories.title}
        </Heading>}
      {isFirst && !mainCategories.title ? <Heading h={1}>
          <span dangerouslySetInnerHTML={sanitizeHtml(mainCategories.description)} />
        </Heading> : <p dangerouslySetInnerHTML={sanitizeHtml(mainCategories.description)} />}
      {mainCategories.link.path ? <Link href={isObject(mainCategories.link) ? prepareURLByCMSLink(mainCategories.link) : mainCategories.link}>
          <Icon icon="ArrowBack" size="37px" color={theme.rawColors.neutralBlack} />
        </Link> : <Icon icon="ArrowBack" size="37px" color={theme.rawColors.neutralBlack} />}
    </div>
    <FurnituresCarousel slides={mainCategories.slides} type={ECarouselType.arrangement} />
  </section>;
export default MainCategoriesSection;